module.exports = __webpack_public_path__ + "img/Arrow-Right-Link.d151b3fc.svg";